import utilits from '@/assets/utilits/request.js'
export default {
  namespaced: true,
  state: {
    userInfo: null
  },
  mutations: {
    updateUserInfo (state, obj) {
      state.userInfo = obj
    }
  },

  actions: {
    login ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/login', obj, callback)
    },
    userLoginOut ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.get, '/cmpapi/logout', obj, callback)
    },
    getUserList ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/getmacowners', obj, callback)
    },
    searchuser ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.get,
        '/cmpapi/searchuser',
        obj,
        callback
      )
    },
    // 搜索EHR用户(设置归属人时使用)
    searchEHRUserByName ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.get,
        '/cmpapi/searchehruser',
        obj,
        callback
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js